export const PRODUCTS_BASE_PATH = '/products';

/**
 * Overlay stack for Products — each layer is a query param so browser Back
 * dismisses modals without leaving /products.
 *
 * /products
 * /products?category=all|{id}
 * /products?category=…&design={id}
 * /products?category=…&design=…&order=new|{orderId}
 */
export function parseProductsOverlay(search) {
  const params = new URLSearchParams(search || '');
  const rawCategory = params.get('category');
  const rawDesign = params.get('design');
  const rawOrder = params.get('order');
  return {
    category: rawCategory != null && rawCategory !== '' ? rawCategory : null,
    design: rawDesign != null && rawDesign !== '' ? rawDesign : null,
    order: rawOrder != null && rawOrder !== '' ? rawOrder : null,
  };
}

export function buildProductsSearch({ category, design, order } = {}) {
  const params = new URLSearchParams();
  if (category != null && category !== '') params.set('category', String(category));
  if (design != null && design !== '') params.set('design', String(design));
  if (order != null && order !== '') params.set('order', String(order));
  const query = params.toString();
  return query ? `?${query}` : '';
}

/** React Router location target for /products with optional overlay params. */
export function productsNavigateTarget({ category, design, order } = {}) {
  return {
    pathname: PRODUCTS_BASE_PATH,
    search: buildProductsSearch({ category, design, order }),
  };
}
